(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Botão acender / apagar — crossfade suave para a 2ª imagem (luminária acesa)
  (function () {
    let lit = false;
    let scheduled = false;

    function ensureOverlay(li) {
      var overlay = li._litOverlay;
      if (overlay && overlay.isConnected) return overlay;
      var gallery = li.querySelector('.card-gallery') || li;
      overlay = document.createElement('img');
      overlay.className = 'lit-overlay';
      overlay.setAttribute('alt', '');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('loading', 'eager');
      overlay.decoding = 'async';
      if (li.dataset.litSrcset) overlay.setAttribute('srcset', li.dataset.litSrcset);
      if (li.dataset.litSrc) overlay.setAttribute('src', li.dataset.litSrc);
      overlay.setAttribute('sizes', (gallery.clientWidth || 400) + 'px');
      gallery.appendChild(overlay);
      li._litOverlay = overlay;
      return overlay;
    }

    function apply() {
      document.querySelectorAll('.product-grid__item[data-lit-src]').forEach(function (li) {
        var overlay = ensureOverlay(li);
        requestAnimationFrame(function () {
          overlay.style.opacity = lit ? '1' : '0';
        });
      });
      document.querySelectorAll('[data-lights-toggle]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', lit ? 'true' : 'false');
        btn.classList.toggle('is-on', lit);
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lights-toggle]');
      if (!btn) return;
      lit = !lit;
      apply();
    });

    // Reaplica o estado quando o grid é re-renderizado (filtros/ordenação)
    var results = document.querySelector('results-list');
    if (results) {
      new MutationObserver(function () {
        if (!lit || scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; apply(); });
      }).observe(results, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
